import React from "react";
import { Row, Col, Button, Modal, Pagination, Checkbox } from "antd";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsChevronCompactDown, BsChevronCompactRight } from "react-icons/bs";
import { AiOutlineComment } from "react-icons/ai";
import { SuccessNotification, ErrorNotification } from "..";
import { archiveChatById } from "@api/copilots/chat";
import "@assets/css/table.css";
import { useTranslation } from "react-i18next";

const ChatsHistoryTable = ({
  page,
  setPage,
  perPage,
  totalChats,
  totalPages,
  chats,
  handleFetchChatsHistoryPaginated,
  expandedRow,
  handleRowClick,
  selectedIds,
  setSelectedIds,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);

  // Handle chat view
  const handleChatView = (id) => {
    history.push(`/a/ws/${user.workspaceId}/history/chat/${id}`);
  };

  // Handle chat archive
  const handleChatArchive = (id) => {
    // Confirm delete
    Modal.confirm({
      title: "Are you sure you want to archive this chat?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          // Archive event
          await archiveChatById(id);
          // Fetch all admin generations
          handleFetchChatsHistoryPaginated(page);
          // Show success notification
          SuccessNotification("Chat archived successfully");
        } catch (error) {
          // Show error notification
          ErrorNotification("Error archiving chat");
        }
      },
    });
  };

  const getTime = (date) => {
    const date1 = date.split("T")[1].split(".")[0];
    return date1;
  };

  const getDate = (date) => {
    const date1 = date.split("T")[0];
    return date1;
  };

  const handleCheckboxChange = (checked, id) => {
    if (checked) {
      setSelectedIds([...selectedIds, id]);
    } else {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    }
  };

  return (
    <>
      <Row gutter={[0, 16]} className="hp-mt-24">
        <Col span={24}>
          <table style={{ width: "100%" }} className="custom-table">
            <tbody>
              {chats?.map((record) => (
                <React.Fragment key={record._id}>
                  <tr key={record._id} className="custom-table-first-row">
                    <td className="custom-table-checkbox">
                      <Checkbox
                        checked={selectedIds.includes(record._id)}
                        onChange={(e) =>
                          handleCheckboxChange(e.target.checked, record._id)
                        }
                      />
                    </td>
                    <td className="custom-table-icon">
                      <div>
                        <AiOutlineComment />
                      </div>
                    </td>
                    <td
                      style={{ width: "70%" }}
                      className="custom-table-first-row-td"
                      onClick={() => handleRowClick(record._id)}
                    >
                      <div className="inputBox">
                        <div>
                          <h5 className="inputText">{record?.chatName}</h5>
                          <div className="inputDateAndTime">
                            <div className="inputDate">
                              {getDate(record.createdAt)}
                            </div>
                            <div className="inputTime">
                              {getTime(record.createdAt)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      className="custom-table-dropdown"
                      onClick={() => handleRowClick(record._id)}
                    >
                      <div className="expand-icon">
                        {expandedRow === record._id ? (
                          <BsChevronCompactRight className="right-icon" />
                        ) : (
                          <BsChevronCompactDown className="down-icon" />
                        )}
                      </div>
                    </td>
                    <td className="custom-table-second-row-td">
                      <div className="buttonBox">
                        <Button
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleChatView(record._id);
                          }}
                          className="viewGenerationBtn"
                        >
                          {t("chatHistory.viewChat")}
                        </Button>
                      </div>
                    </td>
                  </tr>
                  {expandedRow === record._id && (
                    <tr className="custom-table-expanded-row">
                      <td colSpan={6}>
                        <div
                          className={`container custom-table-expanded-content ${
                            expandedRow === record._id ? "show" : ""
                          }`}
                        >
                          <Row
                            gutter={16}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Col
                              className="gutter-row detailsBox expandedTextBox"
                              span={10}
                              offset={2}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  wordBreak: "break-all",
                                  flexWrap: "wrap",
                                  maxWidth: "90%",
                                }}
                              >
                                <h5 className="inputTextTitle">
                                  {t("chatHistory.chatName")}
                                </h5>
                                <p className="inputTextPara">
                                  {record?.chatName}
                                </p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  wordBreak: "break-all",
                                  flexWrap: "wrap",
                                  maxWidth: "90%",
                                }}
                              >
                                <h5 className="inputTextTitle">
                                  {t("chatHistory.totalMessages")}
                                </h5>
                                <p className="inputTextPara">
                                  {record?.messages?.length}
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="dangerButtonBox">
                                <Button
                                  type="danger"
                                  onClick={() => {
                                    handleChatArchive(record._id);
                                  }}
                                  style={{ minWidth: "50px" }}
                                >
                                  {t("chatHistory.delete")}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </Col>
        {/* Pagination */}
        <Col span={24}>
          <Pagination
            current={page}
            pageSize={perPage}
            total={totalChats}
            onChange={(page) => {
              setPage(page);
              handleFetchChatsHistoryPaginated(page);
            }}
            showSizeChanger={false}
          />
        </Col>
      </Row>
    </>
  );
};

export default ChatsHistoryTable;
